<ng-template #content let-modal>
	<div class="modal-header" style="  background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);height: 50px;
  width: 720;">
		<h4 class="modal-title" id="modal-basic-title" style="font-size: 16px;
      font-weight: 500;">
			Save Document
		</h4>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()"> <span aria-hidden="true">
				&times;
			</span> </button>
	</div>
	<div class="modal-body" style="    padding: 40px;">
		<div class="mb-0" id="savefiletext1">
			<label for="file_name" id="saveFileLabel" style="margin-left: 4px !important ;    font-size: 16px;
            font-weight: 500;">Type title of file</label>
			<input class="form-control p-2" id="file_name" style="height: 50px" type="text"
				placeholder="Untitled document" onfocus="this.placeholder=''"
				onblur="this.placeholder='Untitled document'" value="{{ docTitle }}" [(ngModel)]="file_name" required
				(keyup)="saveFile($event)" />
		</div>
		<div class="modal-footer justify-content-start border-0 px-1  pb-4 ms-2 " id="saveSuccessmMsg">
			<button type="button" class="cancle me-4" data-dismiss="modal" (click)="closeModal()"> Cancel </button>
			<button type="submit" class=" submit mr-0" data-dismiss="modal" *ngIf="!docTitle && !file_name" disabled
				(click)="saveFilewithNamenewapi()"> Save </button>
			<button type="submit" class=" submit mr-0" *ngIf="docTitle || file_name" (click)="saveFilewithNamenewapi()">
				Save </button>
		</div>
	</div>
	
</ng-template>
<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)"> Save File </button>